import { useRef, useState } from 'react'
import { useAppStore, useVODStore } from '@/shared/store'
import { useVODService } from '@/app/context/DIContext/DIServices'
import { selectSetVodRowItems } from '@/shared/store/storeSelectors/vodSelectors'
import VodItem from '../../../../../features/VOD/vodClasses/vodItem'
import { fetchItemsAmount } from '@/shared/constants'
import { IVODServiceToya } from '@/shared/types/services/types/vodService/vodServiceInterfaces'
import { filterDuplicates, getErrorMessage } from '@/shared/lib'

export function useVodItemsToya(
    id: string | number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    type: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    serviceName?: string
) {
    const setVodRowItems = useVODStore(selectSetVodRowItems)
    const { getVodItems, createId } = useVODService() as IVODServiceToya

    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const { actualProfile } = useAppStore()
    const { id: profileId } = actualProfile ?? {}
    const vodItemsToAdd = fetchItemsAmount

    const rowItemsRef = useRef<VodItem[]>([])
    const rowIdRef = useRef('')

    const getItems = async (
        rowId?: string,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        query?: string
    ): Promise<VodItem[]> => {
        setIsLoading(true)
        const startItemIndex = 0
        const responseId = createId(rowId || id)

        if (rowIdRef.current !== responseId) {
            rowItemsRef.current = []
        }

        try {
            setIsError(false)
            const response = await getVodItems(
                responseId,
                startItemIndex,
                vodItemsToAdd,
                profileId
            )
            if (response) {
                setVodRowItems(responseId, response)
                const newData = [...rowItemsRef.current, ...response]

                rowItemsRef.current = filterDuplicates(newData, 'id')
                rowIdRef.current = responseId

                return response
            }
        } catch (error) {
            setIsError(true)
            setIsLoading(false)
            getErrorMessage('useVodItems', error)
        } finally {
            setIsLoading(false)
        }

        return []
    }

    const getRecommendationItems = () => null

    const rowItems = rowItemsRef.current

    const setRowItems = (items: VodItem[]) => (rowItemsRef.current = items)

    return {
        rowItems,
        getItems,
        setRowItems,
        isLoading,
        isError,
        getRecommendationItems,
    }
}
